export default "__VITE_ASSET__63fc80e0__"